(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('IntrumentoRelacionadoSearch', IntrumentoRelacionadoSearch);

    IntrumentoRelacionadoSearch.$inject = ['$resource'];

    function IntrumentoRelacionadoSearch($resource) {
        var resourceUrl =  'api/_search/intrumento-relacionados/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
